import { Deserializable } from './deserializable.model';

export class Url implements Deserializable<any, Url> {
  constructor(public url?: string, public type?: string, public dateCreated?: string) {}

  deserialize(input: any): Url {
    if (input == null) {
      return null;
    }

    this.url = input['url'];
    this.type = input['type'];
    this.dateCreated = input['dateCreated'];

    return this;
  }
}
